module.exports = __webpack_public_path__ + "img/desert-discovery.64a211d1.png";